<onafriq-modal>
  <div
    class="bg-white md:h-[191px] md:w-[522px] w-[95%] h-fit rounded-2xl p-7.5 fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
    style="box-shadow: 0px 4px 28px 0px rgba(0, 47, 56, 0.25)">
    <h2 class="text-gray-900 text-h3">Would you like to edit the values before searching?</h2>
    <div class="mt-4 text-gray-900 text-sm flex justify-between flex-wrap">
      <onafriq-input
        *ngFor="let input of multiArray; let i = index"
        [label]="'Value ' + (i + 1)"
        [(inputModel)]="multiArray[i]"
        label="Search" />
    </div>
    <div class="mt-6 flex gap-4 justify-end">
      <onafriq-button type="secondary" label="Cancel" (onClick)="onCancel.emit()" />
      <onafriq-button label="Search" (onClick)="onSearch.emit(multiArray)" />
    </div>
  </div>
</onafriq-modal>
